import { TestingSetupPlanSchema } from '../schemas/testingSchedules'
import { DailyTestingSummarySchema } from '../schemas/dailyTestingSummary'
import { MonitoringKeyResponseSchema } from '../schemas/projectMonitoring'
import type { z } from 'zod'
import { projectDataApi } from './projectDataApi'
import { MonitoringStatusSchema, MonitoringSessionsSchema } from '../schemas/sessionMonitoring'

const api = projectDataApi.injectEndpoints({
  endpoints: builder => ({
    getTestingSetupPlan: builder.query<z.infer<typeof TestingSetupPlanSchema>, string>({
      query: projectId => ({ url: '/api/testing-schedules', params: { project_id: projectId, plan: 'true' } }),
      transformResponse: (response: unknown) => TestingSetupPlanSchema.parse(response),
    }),
    getDailyTestingSummary: builder.query<z.infer<typeof DailyTestingSummarySchema>, { projectId: string; day?: string }>({
      query: ({ projectId, day }) => ({ url: '/api/daily-testing-summary', params: { project_id: projectId, day } }),
      transformResponse: (response: unknown) => DailyTestingSummarySchema.parse(response),
    }),
    getMonitoringSetup: builder.query<z.infer<typeof MonitoringKeyResponseSchema>, string>({
      query: projectId => ({ url: '/api/project-monitoring', method: 'POST', body: { action: 'prepare_setup', project_id: projectId } }),
      transformResponse: (response: unknown) => MonitoringKeyResponseSchema.parse(response),
      keepUnusedDataFor: 300,
    }),
    getMonitoringStatus: builder.query<z.infer<typeof MonitoringStatusSchema>, string>({
      query: projectId => ({ url: '/api/project-session-monitoring', params: { project_id: projectId } }),
      transformResponse: (response: unknown) => MonitoringStatusSchema.parse(response),
      providesTags: (_result, _error, projectId) => [{ type: 'ProjectUserSessions', id: projectId }],
    }),
    getMonitoringSessions: builder.query<z.infer<typeof MonitoringSessionsSchema>, { projectId: string; runId: string; page: number }>({
      query: ({ projectId, runId, page }) => ({ url: '/api/project-session-monitoring', params: { project_id: projectId, run_id: runId, page } }),
      transformResponse: (response: unknown) => MonitoringSessionsSchema.parse(response),
      providesTags: (_result, _error, args) => [{ type: 'ProjectUserSessions', id: args.projectId }],
    }),
  }),
})
export const { useGetTestingSetupPlanQuery, useGetDailyTestingSummaryQuery, useGetMonitoringSetupQuery, useGetMonitoringStatusQuery, useGetMonitoringSessionsQuery } = api
